var exports = {
  "kL": "xaf9ae18d--c5db95--container",
  "Qq": "xaf9ae18d--c5db95--text",
  "b0": "xaf9ae18d--c5db95--ticker",
  "$I": "xaf9ae18d--c5db95--ticker--static",
  "xG": "xaf9ae18d--c5db95--ticker--infinite",
  "fj": "xaf9ae18d--c5db95--tickerInifnite",
};

module.exports = exports;
